import { useTranslation } from 'react-i18next';

export default function Affinity() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 px-8 bg-slate-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="order-2 md:order-1 relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/1599f9d3e2fa18b754e229f35c1a9427.jpg" 
              alt="Communication Breakdown" 
              className="w-full h-full object-cover object-center rounded-lg shadow-lg"
            />
          </div>
          <div className="order-1 md:order-2">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {t('affinity.title')}
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              {t('affinity.paragraph1')}
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('affinity.paragraph2')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
